// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnsLayout_root__28wSW"};